import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const ComoRegalarPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      const slug = searchQuery.toLowerCase()
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '');
      
      navigate(`/lista/${slug}`);
    }
  };

  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-neutral-200 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link to="/" className="flex items-center space-x-2">
            <span className="text-3xl">💝</span>
            <span className="text-2xl font-script font-bold text-accent-600">
              SobreDigital
            </span>
          </Link>
        </div>
      </header>

      {/* Hero */}
      <section className="bg-gradient-to-r from-accent-500 to-primary-500 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-display font-bold mb-4">
            ¿Cómo Regalar?
          </h1>
          <p className="text-xl text-white/90">
            Hacer un regalo es simple y rápido
          </p>
        </div>
      </section>

      {/* Search Box */}
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 -mt-8 relative z-10">
        <div className="bg-white rounded-2xl shadow-xl p-6">
          <h3 className="text-xl font-semibold text-neutral-900 mb-4 text-center">
            Primero, buscá la lista de los novios
          </h3>
          <form onSubmit={handleSearch}>
            <div className="relative">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Nombre de los novios..."
                className="w-full px-6 py-4 text-lg rounded-xl border-2 border-neutral-300 focus:border-accent-500 focus:outline-none focus:ring-4 focus:ring-accent-100 transition-all"
              />
              <button
                type="submit"
                className="absolute right-2 top-1/2 -translate-y-1/2 bg-accent-500 text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-accent-600 transition-all"
              >
                Buscar
              </button>
            </div>
          </form>
        </div>
      </section>

      {/* Steps */}
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="text-3xl font-display font-bold text-neutral-900 text-center mb-12">
          Paso a Paso
        </h2>

        <div className="space-y-8">
          {/* Step 1 */}
          <div className="flex gap-6 items-start">
            <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-accent-500 to-accent-600 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg">
              1
            </div>
            <div className="flex-1">
              <h3 className="text-2xl font-display font-semibold text-neutral-900 mb-3">
                Buscá la Lista
              </h3>
              <p className="text-neutral-700 mb-4">
                Usá el buscador de arriba o el link que te compartieron los novios. 
                Ingresá el nombre de la pareja (por ejemplo: "María y Juan").
              </p>
              <div className="bg-accent-50 border border-accent-200 rounded-lg p-4">
                <p className="text-sm text-accent-900">
                  <strong>💡 Tip:</strong> Si te compartieron un link directo, solo hacé click y llegás directo a la lista.
                </p>
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="flex gap-6 items-start">
            <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-primary-500 to-primary-600 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg">
              2
            </div>
            <div className="flex-1">
              <h3 className="text-2xl font-display font-semibold text-neutral-900 mb-3">
                Elegí un Regalo
              </h3>
              <p className="text-neutral-700 mb-4">
                Navegá por la galería de regalos. Podés filtrar por categoría (electrodomésticos, viajes, hogar, etc.). 
                Los regalos ya seleccionados por otros invitados aparecen marcados.
              </p>
              <div className="grid sm:grid-cols-2 gap-4 mt-4">
                <div className="bg-white border-2 border-neutral-200 rounded-lg p-4">
                  <div className="text-3xl mb-2">✅</div>
                  <p className="text-sm font-semibold text-neutral-900">Disponible</p>
                  <p className="text-xs text-neutral-600">Podés regalarlo</p>
                </div>
                <div className="bg-neutral-100 border-2 border-neutral-300 rounded-lg p-4 opacity-60">
                  <div className="text-3xl mb-2">🎁</div>
                  <p className="text-sm font-semibold text-neutral-700">Ya regalado</p>
                  <p className="text-xs text-neutral-600">Elegí otro</p>
                </div>
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="flex gap-6 items-start">
            <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-gold-500 to-gold-600 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg">
              3
            </div>
            <div className="flex-1">
              <h3 className="text-2xl font-display font-semibold text-neutral-900 mb-3">
                Completá tus Datos
              </h3>
              <p className="text-neutral-700 mb-4">
                Ingresá tu nombre, email y teléfono. Podés agregar una dedicatoria personal que los novios verán junto con tu regalo.
              </p>
              <div className="bg-gold-50 border border-gold-200 rounded-lg p-4">
                <p className="text-sm text-gold-900">
                  <strong>✨ Dedicatoria:</strong> Hace tu regalo más especial con un mensaje personalizado. 
                  Los novios lo apreciarán!
                </p>
              </div>
            </div>
          </div>

          {/* Step 4 */}
          <div className="flex gap-6 items-start">
            <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg">
              4
            </div>
            <div className="flex-1">
              <h3 className="text-2xl font-display font-semibold text-neutral-900 mb-3">
                Elegí Cómo Pagar
              </h3>
              <p className="text-neutral-700 mb-4">
                Tenés varias opciones de pago seguras:
              </p>
              <div className="grid sm:grid-cols-2 gap-3">
                <div className="bg-white border border-neutral-200 rounded-lg p-3">
                  <p className="font-semibold text-sm">💳 MercadoPago</p>
                  <p className="text-xs text-neutral-600">Tarjeta o efectivo</p>
                </div>
                <div className="bg-white border border-neutral-200 rounded-lg p-3">
                  <p className="font-semibold text-sm">🏦 Transferencia</p>
                  <p className="text-xs text-neutral-600">Desde tu banco</p>
                </div>
                <div className="bg-white border border-neutral-200 rounded-lg p-3">
                  <p className="font-semibold text-sm">💵 Depósito</p>
                  <p className="text-xs text-neutral-600">En cajero o sucursal</p>
                </div>
                <div className="bg-white border border-neutral-200 rounded-lg p-3">
                  <p className="font-semibold text-sm">🌐 PayPal</p>
                  <p className="text-xs text-neutral-600">Desde el exterior</p>
                </div>
              </div>
              <Link to="/formas-de-pago" className="text-accent-600 hover:text-accent-700 text-sm font-medium mt-3 inline-block">
                Ver detalles de cada método →
              </Link>
            </div>
          </div>

          {/* Step 5 */}
          <div className="flex gap-6 items-start">
            <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg">
              5
            </div>
            <div className="flex-1">
              <h3 className="text-2xl font-display font-semibold text-neutral-900 mb-3">
                ¡Listo!
              </h3>
              <p className="text-neutral-700 mb-4">
                Una vez confirmado el pago, los novios reciben una notificación con tu nombre, el regalo y tu mensaje. 
                El dinero se deposita directamente en su cuenta bancaria.
              </p>
              <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
                <p className="text-sm text-purple-900">
                  <strong>🎉 ¡Gracias!</strong> Tu regalo ayuda a la pareja a comenzar su nueva vida juntos.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-gradient-to-r from-accent-50 to-primary-50 rounded-2xl p-8">
          <h2 className="text-2xl font-display font-bold text-neutral-900 mb-6 text-center">
            Preguntas Frecuentes
          </h2>
          
          <div className="space-y-4">
            <div>
              <h4 className="font-semibold text-neutral-900 mb-2">¿Necesito crear una cuenta?</h4>
              <p className="text-neutral-700">
                No. Para hacer un regalo no necesitás registrarte ni crear ninguna cuenta.
              </p>
            </div>
            
            <div>
              <h4 className="font-semibold text-neutral-900 mb-2">¿Los novios reciben mi mensaje?</h4>
              <p className="text-neutral-700">
                Sí. Tu dedicatoria aparece en su panel junto con tu nombre y el regalo que elegiste.
              </p>
            </div>
            
            <div>
              <h4 className="font-semibold text-neutral-900 mb-2">¿Puedo hacer un regalo compartido?</h4>
              <p className="text-neutral-700">
                Sí. Varios invitados pueden contribuir para un mismo regalo. El sistema suma automáticamente las contribuciones.
              </p>
            </div>
          </div>

          <div className="mt-6 text-center">
            <Link to="/faq" className="text-accent-600 hover:text-accent-700 font-semibold">
              Ver todas las preguntas →
            </Link>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-gradient-to-r from-accent-500 to-primary-500 rounded-2xl p-8 text-center text-white">
          <h2 className="text-3xl font-display font-bold mb-4">
            ¿Listo para hacer tu regalo?
          </h2>
          <p className="text-xl mb-6 text-white/90">
            Buscá la lista y empezá ahora
          </p>
          <Link to="/" className="bg-white text-accent-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gold-100 transition-all inline-block">
            Buscar Lista
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-neutral-900 text-white py-8 mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Link to="/" className="text-neutral-400 hover:text-white transition-colors">
            ← Volver al inicio
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default ComoRegalarPage;
